<template>
	<div class="plr20 pt20 page_bg" style="box-sizing: border-box;">
		<div class="bgfff mb20 b_r_10 plr20 pt20 pb20 mb20">
			<div class="page_title mb10">项目信息</div>
			<div class="pl15">
				<div class="flex flex_start mb20 flex_items">
					<div class="ca6 mr10 l1">项目名称</div>
					<div class="flex1 l1">{{detail.name}}</div>
				</div>
			</div>
		</div>
		<div class="t bgfff flex flex_between plr20 pt20 pb20" style="border-radius: 10px 10px 0 0;">
			<div class="flex flex_column txt_center" @click="$router.push({path:'/checkWork',query:{id:id}})">
				<van-icon name="orders-o" class="mb10" size="40" />
				今日考勤
			</div>
			<div class="flex flex_column txt_center" @click="$router.push({path:'/offAtt',query:{id:id,t:1}})">
				<van-icon name="notes-o" class="mb10" size="40" />
				出勤
			</div>
			<div class="flex flex_column txt_center" @click="$router.push({path:'/offscore',query:{id:id,t:1}})">
				<van-icon name="todo-list-o" class="mb10" size="40" />
				积分明细
			</div>
		</div>
		<div class="t bgfff flex flex_between plr20 pt20 pb20" style="border-radius: 10px 10px 0 0;">
			<div class="flex flex_column txt_center" @click="$router.push({path:'/offAtt',query:{id:id,t:2}})">
				<van-icon name="orders-o" class="mb10" size="40" />
				出勤汇总
			</div>
			<div class="flex flex_column txt_center" @click="$router.push({path:'/offscore',query:{id:id,t:2}})">
				<van-icon name="notes-o" class="mb10" size="40" />
				积分汇总
			</div>
			<div class="flex flex_column txt_center" style="opacity: 0;">
				<van-icon name="todo-list-o" class="mb10" size="40" />
				积分明细
			</div>
		</div>
		<div class="mt20 pb20 bgfff pt20">
			<div class="plr20 mb20">
				<div class="page_title mb10">日程表</div>
			</div>
			<Calendar :markDate2="havecheck" v-on:changeMonth="changeDate">
			</Calendar>
		</div>
	</div>
</template>
<script>
	import Calendar from '@/components/calendar/calendar.vue';
	import { Dialog } from 'vant';
	export default ({
		data() {
			return {
				detail: {},
				id: 1,
				havecheck: []
			}
		},
		components:{
			Calendar
		},
		created() {
			this.id = this.$route.query.id;
			this.getList();
			this.planList()
		},
		methods: {
			getList() {
				this.api.projectView({},this.id).then(res => {
					this.detail = res.data
				})
			},
			planList(){
				let arr = []
				this.api.planList({},this.id).then(res => {
					// this.pl = res.data
					res.data.map(r => {
						let day = r.days ? JSON.parse(r.days) : []
						let ym = r.month.substr(0,4)+'/'+Number(r.month.substr(4,2))+'/';
						day.map(d => {
							arr.push(ym+d)
						})
					})
					// console.log(arr)
					this.havecheck = arr
				})
			},
			changeDate(e){
				// console.log(e)
			}
		}
	})
</script>
<style scoped="scoped">
	.t>div{
		width: 28%;
	}
</style>